export default "__VITE_ASSET__BthPj2NN__"